<template>
    <div class="tabbed-content">
        <div class="row title-bar no-gutters" v-if="!isMobile">
            <div class="col-md" v-for="(tab, index) in tabs">
                <div class="title-wrapper" @click="setCurrentTabIndex(index)"
                     :class="{
                        'left-radius': index === 0,
                        'right-radius': index === tabs.length - 1,
                        'active': index === currentTabIndex
                     }"
                     v-html="tab.title">
                </div>
            </div>
        </div>
        <select v-else v-model="currentTabIndex" @change="setCurrentTab" class="form-control mb-4">
            <option v-for="(tab, index) in tabs" v-bind:value="index">
                {{ tab.title }}
            </option>
        </select>
        <div class="row" v-for="(tab, index) in tabs" v-show="index === currentTabIndex">
            <div class="col-md-5 ml-md-5 order-1 order-xl-0">
                <div class="content" v-html="tab.text"></div>
            </div>
            <div class="col-md-6 order-0 order-xl-1 mb-5 mb-xl-0">
                <img :data-src="tab.image" :alt="tab.title" class="img img-fluid lozad mt-5 mt-xl-0"
                     :data-srcset="tab.imageSrcset">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tabbed-content',
    props: {
        tabs: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            currentTabIndex: 0,
        }
    },
    computed: {
        isMobile() {
            let windowWidth = window.innerWidth
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                    windowWidth < 991
        }
    },
    mounted() {
        this.$lozad.observe()
    },
    methods: {
        setCurrentTab() {
            this.$lozad.observe()
        },
        setCurrentTabIndex(index) {
            this.currentTabIndex = index
        }
    },
}
</script>

<style scoped lang="scss">
@import "../../scss/variables";

$border-radius: 30px;
$light-red: #F0D2D5;

.title-bar {
    background-color: $light-red;
    border-radius: $border-radius;
    margin: 60px 0;

    .col {

        &:last-of-type {
            border-right: 0;
        }
    }

    .title-wrapper {
        padding: 15px 10px;
        text-align: center;
        color: $gray-700;
        transition: all .3s ease-in-out;
        cursor: pointer;
        background-color: $light-red;
        border-radius: $border-radius;
        font-weight: 600;
        font-size: 22px;

        &:hover {
            color: lighten($gray-700, 20);
        }

        &.active {
            background-color: $secondary;
            color: $white;
        }

        &.left-radius {
            border-top-left-radius: $border-radius;
            border-bottom-left-radius: $border-radius;
        }


        &.right-radius {
            border-top-right-radius: $border-radius;
            border-bottom-right-radius: $border-radius;
        }
    }
}
</style>